module.exports = require("@angular/material/core");


//////////////////
// WEBPACK FOOTER
// external "@angular/material/core"
// module id = 997
// module chunks = 0